
var TECL_TenderCreateNewAccount = {

  // Initialise the page
  Initialise: function () {
    TECL_Master.StopKendoDropDownScrollBug();

    TECL_OrgQuickSearch.Initialise($('#schoolSearch'), {
      ReturnMatAswell: true
    });

    $("#schoolSearch").on("itemSelected", function (event, data_id, data_name) {
      $('#orgId').val($('#schoolSearch').attr("data_id"));
    });
  },

  // Clear all validation error text
  ClearValidationErrors: function () {
    $("#errUserDetailsOrganisationNoSearchEntries").addClass("hidden");
    $("#errUserDetailsFirstName").addClass("hidden");
    $("#errUserDetailsLastName").addClass("hidden");
    $("#errUserDetailsOrganisation").addClass("hidden");
    $("#errUserDetailsPosition").addClass("hidden");
    $("#errUserDetailsEmailAddress").addClass("hidden");
    $("#errUserDetailsUsedEmailAddress").addClass("hidden");
    $("#errUserDetailsConfirmEmailAddress").addClass("hidden");
    $("#errUserDetailsPassword").addClass("hidden");
    $("#errUserDetailsConfirmPassword").addClass("hidden");
    $("#errLoginEmailAddress").addClass("hidden");
    $("#errLoginPassword").addClass("hidden");
    $("#errLoginFail").addClass("hidden");
    $("#acceptTandCsErr").addClass("hidden");
  },

  // Validate the user info section
  ValidateUserInfo: function () {
    TECL_TenderCreateNewAccount.ClearValidationErrors();

    var webAccountId = $("#userWebAccountIdVal").val();
    var webAccountEmailAddress = $("#userWebAccountEmailAddressVal").val();
    var firstName = $("#userFirstNameVal").val();
    var lastName = $("#userLastNameVal").val();
    var organisationId = $("#orgId").val();
    var positionId = $("#ddlPositions").val();
    var emailAddress = $("#userEmailAddressVal").val();
    var confirmEmailAddress = $("#userConfirmEmailAddressVal").val();
    var password = $("#userPasswordVal").val();
    var tandcChecked = $("#acceptTandCs").is(":checked");

    var noErrors = true;

    if (!firstName) {
      $("#errUserDetailsFirstName").removeClass("hidden");
      noErrors = false;
    }

    if (!lastName) {
      $("#errUserDetailsLastName").removeClass("hidden");
      noErrors = false;
    }

    if (!organisationId) {
      $("#errUserDetailsOrganisation").removeClass("hidden");
      noErrors = false;
    }

    if (!positionId) {
      $("#errUserDetailsPosition").removeClass("hidden");
      noErrors = false;
    }
    if (!emailAddress || !TECL_Master.IsEmailAddress(emailAddress)) {
      $("#errUserDetailsEmailAddress").removeClass("hidden");
      noErrors = false;

    } else if ((!webAccountEmailAddress || webAccountEmailAddress === "" || webAccountEmailAddress !== emailAddress) &&
      TECL_TenderUserInformation.ValidateEmailAddressAlreadyExists(webAccountId, emailAddress)) {
      $("#errUserDetailsUsedEmailAddress").removeClass("hidden");
      noErrors = false;

    } else if (emailAddress !== confirmEmailAddress) {
      $("#errUserDetailsConfirmEmailAddress").removeClass("hidden");
      noErrors = false;
    }

    if (!password || password.length < 5) {
      $("#errUserDetailsPassword").removeClass("hidden");
      noErrors = false;
    }

    if (!tandcChecked) {
      $("#acceptTandCsErr").removeClass("hidden");
      noErrors = false;
    }

    return noErrors;
  },

  // Create user
  CreateUser: function () {

    if (TECL_Master.AddLock("TECL_TenderCreateNewAccount.CreateUser")) {

      if (TECL_TenderCreateNewAccount.ValidateUserInfo()) {
        TECL_TenderGeneral.DisplayPleaseWaitDlg();

        var userInfoData = TECL_TenderCreateNewAccount.SerialisedData();

        // Call Server to save the tender
        $.ajax({
          url: baseSiteUrl + "umbraco/Surface/TenderUserSurface/CreateWebAccount",
          type: "POST",
          dataType: "json",
          data: {
            data: userInfoData
          },
          error: function (exc) {
            TECL_TenderGeneral.HidePleaseWaitDlg();
            TECL_Master.ClearLock("TECL_TenderCreateNewAccount.CreateUser");
            TECL_Master.ShowErrorDialog();
          },
          success: function (viewModel) {
            TECL_Master.ClearLock("TECL_TenderCreateNewAccount.CreateUser");
            TECL_TenderGeneral.HidePleaseWaitDlg();

            if (viewModel.Saved && viewModel.NextPageUrl) {
              window.location.replace(viewModel.NextPageUrl);
            } else if (viewModel.ErrorMessage) {
              TECL_Master.ShowErrorDialog(viewModel.ErrorMessage);
            } else {
              TECL_Master.ShowErrorDialog();
            }
          }
        });
      } else {
        TECL_Master.ClearLock("TECL_TenderCreateNewAccount.CreateUser");
      }
    }
  },

  // Get the Serialised Data
  SerialisedData: function () {
    //get standard data
    const firstName = $("#userFirstNameVal").val();
    const lastName = $("#userLastNameVal").val();
    const positionId = $("#ddlPositions").val();
    const emailAddress = $("#userEmailAddressVal").val();
    const password = $("#userPasswordVal").val();
    const organisationId = $("#orgId").val();
    const organisationName = $("#schoolSearch").val();
    const jobTypeId = $("#ddlPositions").val();

    const userInfoData = {
      FirstName: firstName,
      LastName: lastName,
      OrganisationId: organisationId,
      OrganisationName: organisationName,
      PositionId: positionId,
      EmailAddress: emailAddress,
      Password: password,
      JobTypeId: jobTypeId
    }
    return userInfoData;
  }

};